const B2B_LOCAL = 'pro-local';
const B2C_LOCAL = 'local';
const B2B_STAGING = 'pro-staging';
const B2C_STAGING = 'staging';
const B2B_PROD = 'pro-production';
// Commented to avoid warning because this env name is unused in the codebase for now
// const B2C_PROD = 'production';

export const B2B_APP_ENVS = [B2B_LOCAL, B2B_STAGING, B2B_PROD];

export const IN_DEVELOPMENT_ENVS = [B2C_LOCAL, B2C_STAGING, B2B_LOCAL, B2B_STAGING];
